import { jsx } from 'react/jsx-runtime';
import { useEffect } from 'react';
import Color from 'color';
import { styled } from 'styled-components';
import { cssAnimations } from '@fabric-app/ui/constants/cssAnimations';
import { getUserColorFromId } from '@fabric-app/utils/color';

const Click = styled.span.withConfig({
  displayName: "SpaceClick__Click",
  componentId: "sc-613f6fc3-0"
})([
  `width:30px;height:30px;flex-shrink:0;position:absolute;border-radius:50%;animation:`,
  ` 1s cubic-bezier(0,0,0.2,1) forwards;`
], cssAnimations.ping.keyframe);
const SpaceClick = ({ event, bodyContext, dismiss }) => {
  const x = event.position.x * (bodyContext.size?.width ?? 0) - 5;
  const y = event.position.y * (bodyContext.size?.height ?? 0) - 5;
  const color = getUserColorFromId(event.user.id);
  const alphaColor = new Color(color).alpha(0.2).toString();
  useEffect(() => {
    setTimeout(() => {
      dismiss();
    }, 1e3);
  }, [
    dismiss
  ]);
  return /* @__PURE__ */ jsx(Click, {
    style: {
      left: x,
      top: y,
      backgroundColor: alphaColor
    }
  });
};

export { SpaceClick as default };
//# sourceMappingURL=SpaceClick.js.map
